import { render, staticRenderFns } from "./InternationalPaymentsReview.vue?vue&type=template&id=353cfae0"
import script from "./InternationalPaymentsReview.vue?vue&type=script&lang=js"
export * from "./InternationalPaymentsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports